import moment from 'moment-timezone';
import { DATE_SHORTCUTS } from '@utils/constants';
import { calcShortcutInterval } from '@utils';

// common
export const DRY_RUN_CUSTOMER_ID = [1960180521];

export const STARTED_SELF_SERVE_STAGE = 'startedSelfServe';
export const WAITING_ACTIVATED_STAGE = 'waitingActivated';
export const NON_INTEGRATED_STAGE = 'nonIntegrated';
export const INTEGRATED_BUT_NOT_VISITED_PULSE_STAGE = 'integratedButNotVisitedPulse';
export const USED_TRENDS_STAGE = 'usedTrends';
export const INTEGRATED_STAGE = 'integrated';

export const allStages = [
  STARTED_SELF_SERVE_STAGE,
  WAITING_ACTIVATED_STAGE,
  NON_INTEGRATED_STAGE,
  INTEGRATED_BUT_NOT_VISITED_PULSE_STAGE,
  USED_TRENDS_STAGE,
  INTEGRATED_STAGE,
];

export const DATE_OPTIONS = [
  {
    label: DATE_SHORTCUTS.today,
    value: DATE_SHORTCUTS.today,
  },
  {
    label: DATE_SHORTCUTS.past7Days,
    value: DATE_SHORTCUTS.past7Days,
  },
  {
    label: DATE_SHORTCUTS.past15Days,
    value: DATE_SHORTCUTS.past15Days,
  },
  {
    label: DATE_SHORTCUTS.past30Days,
    value: DATE_SHORTCUTS.past30Days,
  },
  {
    label: 'Last 45 days',
    value: 'past45Days',
  },
  {
    label: DATE_SHORTCUTS.past90Days,
    value: DATE_SHORTCUTS.past90Days,
  },
];

export function calcInterval(shortcut) {
  switch (shortcut) {
    case 'past45Days':
      return [
        moment().subtract(45, 'days').startOf('day'),
        moment().subtract(1, 'day').endOf('day'),
      ];
    default:
      return calcShortcutInterval(shortcut);
  }
}

// timeline
export const orderedTimeFields: string[] = [
  'start_self_serve_at',
  'access_welcome_page_at',
  'access_integrate_page_at',
  'receive_data_at',
  'access_trends_page_at',
];

export const timeFieldDisplayNames: Record<string, { text: string; tooltip?: string }> = {
  start_self_serve_at: {
    text: 'Newly Started Self-Serve',
    tooltip: 'Enabled Self-Serve in the Portal.',
  },
  access_welcome_page_at: {
    text: 'Accessed Welcome Page',
  },
  access_integrate_page_at: {
    text: 'Accessed Integration Page',
  },
  receive_data_at: {
    text: 'Integrated',
    tooltip: 'The "Generating Data For Trends" button became clickable in the integration page.',
  },
  access_trends_page_at: {
    text: 'Explored Trends',
    tooltip: 'Completed Trends Visiting.',
  },
};

// conversion funnel
export const FUNNEL_SHOW_LIMIT = 10;

export const funnelStages = [
  'Newly Started Self-Serve(Enabled Self-Serve in the Portal)',
  'Integrated(The "Generating Data For Trends" button became clickable in the integration page)',
  'Explored Trends(Completed Trends Visiting)',
];
export const funnelFieldMap: Record<string, string> = {
  [funnelStages[0]]: 'start_self_serve_at',
  [funnelStages[1]]: 'receive_data_at',
  [funnelStages[2]]: 'access_trends_page_at',
};

// metric panel
export const METRIC_STAGE_MAP = {
  awaitingActivation: {
    label: 'Accounts Awaiting Activation',
    columnTitle: 'Duration in Awaiting Activation',
    columnTitleToolTip:
      'Duration from enabling Self-Serve to accessing the Welcome Page (or current time if not accessed the Welcome Page).',
    value: WAITING_ACTIVATED_STAGE,
    metricTooltip: 'Accounts that have enabled self-serve but have no activated users yet.',
  },
  awaitingIntegration: {
    label: 'Accounts Awaiting Integration',
    columnTitle: 'Duration in Awaiting Integration',
    columnTitleToolTip:
      "Duration from accessing the Welcome Page to 'Integrated' (or current time if not 'Integrated').",
    value: NON_INTEGRATED_STAGE,
    metricTooltip: 'Accounts with activated users but without completing integration.',
  },
  notExploringTrends: {
    label: 'Accounts Not Exploring Trends',
    columnTitle: 'Duration in Not Exploring Trends',
    columnTitleToolTip:
      "Duration from 'Integrated' to accessing Trends (or current time if not accessed Trends).",
    value: INTEGRATED_BUT_NOT_VISITED_PULSE_STAGE,
    metricTooltip: 'Accounts that have completed integration but have never visited the Trends.',
  },
};

export const METRIC_PANEL_CONFIG = [
  {
    key: 'awaitingActivation',
    stageKey: WAITING_ACTIVATED_STAGE,
  },
  {
    key: 'awaitingIntegration',
    stageKey: NON_INTEGRATED_STAGE,
  },
  {
    key: 'notExploringTrends',
    stageKey: INTEGRATED_BUT_NOT_VISITED_PULSE_STAGE,
  },
];

export const TABLE_LIST_OPTIONS = [
  METRIC_STAGE_MAP.awaitingActivation,
  METRIC_STAGE_MAP.awaitingIntegration,
  METRIC_STAGE_MAP.notExploringTrends,
];
